import React from 'react';
import MenuMui, { MenuProps } from '@material-ui/core/Menu';

export const Menu: React.FC<MenuProps> = ({ children, ...rest }) => {
	return <MenuMui {...rest}>{children}</MenuMui>;
};
